(() => {
  'use strict';
  var r = {
      d: (t, e) => {
        for (var n in e) r.o(e, n) && !r.o(t, n) && Object.defineProperty(t, n, { enumerable: !0, get: e[n] });
      },
      o: (r, t) => Object.prototype.hasOwnProperty.call(r, t),
      r: (r) => {
        'undefined' != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(r, Symbol.toStringTag, { value: 'Module' }),
          Object.defineProperty(r, '__esModule', { value: !0 });
      },
    },
    t = {};
  function e(r) {
    return (
      (function (r) {
        if (Array.isArray(r)) return o(r);
      })(r) ||
      (function (r) {
        if (('undefined' != typeof Symbol && null != r[Symbol.iterator]) || null != r['@@iterator'])
          return Array.from(r);
      })(r) ||
      n(r) ||
      (function () {
        throw new TypeError(
          'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
        );
      })()
    );
  }
  function n(r, t) {
    if (r) {
      if ('string' == typeof r) return o(r, t);
      var e = Object.prototype.toString.call(r).slice(8, -1);
      return (
        'Object' === e && r.constructor && (e = r.constructor.name),
        'Map' === e || 'Set' === e
          ? Array.from(r)
          : 'Arguments' === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)
          ? o(r, t)
          : void 0
      );
    }
  }
  function o(r, t) {
    (null == t || t > r.length) && (t = r.length);
    for (var e = 0, n = new Array(t); e < t; e++) n[e] = r[e];
    return n;
  }
  function a(r) {
    return (
      (a =
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? function (r) {
              return typeof r;
            }
          : function (r) {
              return r && 'function' == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype
                ? 'symbol'
                : typeof r;
            }),
      a(r)
    );
  }
  r.r(t), r.d(t, { Fragment: () => i, jsx: () => u, jsxs: () => f });
  var i = Symbol.for('El.fragment');
  function l(r) {
    for (var t = r.flat(), e = [], n = 0; n < t.length; ++n)
      'boolean' != typeof t[n] && void 0 !== t[n] && null !== t[n] && e.push(t[n]);
    return e;
  }
  var u = function (r, t) {
      var o = null;
      if (
        (t && void 0 !== t.children && (o = Array.isArray(t.children) ? l(t.children) : l([t.children])),
        'symbol' === a(r))
      ) {
        if (r.valueOf() === i.valueOf()) {
          var u = document.createDocumentFragment();
          return o && o.length > 0 && u.append.apply(u, e(o)), u;
        }
        throw new Error("JSX Error: invalid symbol '".concat(r.valueOf, "'"));
      }
      var f = document.createElement(r);
      return (
        t &&
          Object.entries(t).forEach(function (r) {
            var t,
              e,
              o =
                ((e = 2),
                (function (r) {
                  if (Array.isArray(r)) return r;
                })((t = r)) ||
                  (function (r, t) {
                    var e = null == r ? null : ('undefined' != typeof Symbol && r[Symbol.iterator]) || r['@@iterator'];
                    if (null != e) {
                      var n,
                        o,
                        a,
                        i,
                        l = [],
                        u = !0,
                        f = !1;
                      try {
                        if (((a = (e = e.call(r)).next), 0 === t)) {
                          if (Object(e) !== e) return;
                          u = !1;
                        } else for (; !(u = (n = a.call(e)).done) && (l.push(n.value), l.length !== t); u = !0);
                      } catch (r) {
                        (f = !0), (o = r);
                      } finally {
                        try {
                          if (!u && null != e.return && ((i = e.return()), Object(i) !== i)) return;
                        } finally {
                          if (f) throw o;
                        }
                      }
                      return l;
                    }
                  })(t, e) ||
                  n(t, e) ||
                  (function () {
                    throw new TypeError(
                      'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
                    );
                  })()),
              a = o[0],
              i = o[1];
            if ('children' !== a)
              if ('class' !== a)
                a.indexOf('-') > -1
                  ? 'string' == typeof i
                    ? f.setAttribute(a, i)
                    : i.toString && 'function' == typeof i.toString && f.setAttribute(a, i.toString())
                  : (f[a] = i);
              else {
                var l,
                  u = (function (r, t) {
                    var e = ('undefined' != typeof Symbol && r[Symbol.iterator]) || r['@@iterator'];
                    if (!e) {
                      if (Array.isArray(r) || (e = n(r))) {
                        e && (r = e);
                        var o = 0,
                          a = function () {};
                        return {
                          s: a,
                          n: function () {
                            return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] };
                          },
                          e: function (r) {
                            throw r;
                          },
                          f: a,
                        };
                      }
                      throw new TypeError(
                        'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
                      );
                    }
                    var i,
                      l = !0,
                      u = !1;
                    return {
                      s: function () {
                        e = e.call(r);
                      },
                      n: function () {
                        var r = e.next();
                        return (l = r.done), r;
                      },
                      e: function (r) {
                        (u = !0), (i = r);
                      },
                      f: function () {
                        try {
                          l || null == e.return || e.return();
                        } finally {
                          if (u) throw i;
                        }
                      },
                    };
                  })(i.trim().replace(/\s+/, ' ').split(' '));
                try {
                  for (u.s(); !(l = u.n()).done; ) {
                    var c = l.value;
                    f.classList.add(c);
                  }
                } catch (r) {
                  u.e(r);
                } finally {
                  u.f();
                }
              }
          }),
        o && o.length > 0 && f.append.apply(f, e(o)),
        f
      );
    },
    f = u;
  (exports.Fragment = t.Fragment),
    (exports.jsx = t.jsx),
    (exports.jsxs = t.jsxs),
    Object.defineProperty(exports, '__esModule', { value: !0 });
})();
